/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as GuestRouteImport } from './routes/_guest'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppAiRouteImport } from './routes/_app/ai'
import { Route as AppOverviewRouteImport } from './routes/_app/overview'
import { Route as GuestForgotPasswordRouteImport } from './routes/_guest/forgot-password'
import { Route as GuestLoginRouteImport } from './routes/_guest/login'
import { Route as GuestRegisterRouteImport } from './routes/_guest/register'
import { Route as GuestResetPasswordRouteImport } from './routes/_guest/reset-password'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account/index'
import { Route as AppAccountActivityRouteImport } from './routes/_app/account/activity'
import { Route as AppAccountAiRouteImport } from './routes/_app/account/ai'
import { Route as AppAccountApiKeysRouteImport } from './routes/_app/account/api-keys'
import { Route as AppAccountSecurityRouteImport } from './routes/_app/account/security'
import { Route as AppAccountSettingsRouteImport } from './routes/_app/account/settings'
import { Route as AppAccountSshKeysRouteImport } from './routes/_app/account/ssh-keys'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAdminActivityRouteImport } from './routes/_app/admin/activity'
import { Route as AppAdminAiRouteImport } from './routes/_app/admin/ai'
import { Route as AppAdminAllocationsRouteImport } from './routes/_app/admin/allocations'
import { Route as AppAdminApiKeysRouteImport } from './routes/_app/admin/api-keys'
import { Route as AppAdminCustomisationRouteImport } from './routes/_app/admin/customisation'
import { Route as AppAdminDatabaseHostsRouteImport } from './routes/_app/admin/database-hosts'
import { Route as AppAdminLocationsRouteImport } from './routes/_app/admin/locations'
import { Route as AppAdminSettingsRouteImport } from './routes/_app/admin/settings'
import { Route as AppAiIndexRouteImport } from './routes/_app/ai/index'
import { Route as AppAiConversationIdRouteImport } from './routes/_app/ai/$conversationId'
import { Route as AppCustomSlugRouteImport } from './routes/_app/custom.$slug'
import { Route as AppServerServerRouteImport } from './routes/_app/server/$server'
import { Route as AppAdminCustomisationIndexRouteImport } from './routes/_app/admin/customisation/index'
import { Route as AppAdminCustomisationAiRouteImport } from './routes/_app/admin/customisation/ai'
import { Route as AppAdminCustomisationBrandingRouteImport } from './routes/_app/admin/customisation/branding'
import { Route as AppAdminCustomisationDashboardRouteImport } from './routes/_app/admin/customisation/dashboard'
import { Route as AppAdminCustomisationHistoryRouteImport } from './routes/_app/admin/customisation/history'
import { Route as AppAdminCustomisationLoginRouteImport } from './routes/_app/admin/customisation/login'
import { Route as AppAdminCustomisationPagesRouteImport } from './routes/_app/admin/customisation/pages'
import { Route as AppAdminCustomisationServerRouteImport } from './routes/_app/admin/customisation/server'
import { Route as AppAdminCustomisationTenantsRouteImport } from './routes/_app/admin/customisation/tenants'
import { Route as AppAdminCustomisationThemeRouteImport } from './routes/_app/admin/customisation/theme'
import { Route as AppAdminEggsEggIdRouteImport } from './routes/_app/admin/eggs/$eggId'
import { Route as AppAdminGameProfilesIndexRouteImport } from './routes/_app/admin/game-profiles/index'
import { Route as AppAdminGameProfilesProfileIdRouteImport } from './routes/_app/admin/game-profiles/$profileId'
import { Route as AppAdminGameProfilesNewRouteImport } from './routes/_app/admin/game-profiles/new'
import { Route as AppAdminNestsIndexRouteImport } from './routes/_app/admin/nests/index'
import { Route as AppAdminNodesIndexRouteImport } from './routes/_app/admin/nodes/index'
import { Route as AppAdminNodesNodeIdRouteImport } from './routes/_app/admin/nodes/$nodeId'
import { Route as AppAdminNodesNewRouteImport } from './routes/_app/admin/nodes/new'
import { Route as AppAdminServersIndexRouteImport } from './routes/_app/admin/servers/index'
import { Route as AppAdminServersServerIdRouteImport } from './routes/_app/admin/servers/$serverId'
import { Route as AppAdminServersImportRouteImport } from './routes/_app/admin/servers/import'
import { Route as AppAdminServersNewRouteImport } from './routes/_app/admin/servers/new'
import { Route as AppAdminUsersIndexRouteImport } from './routes/_app/admin/users/index'
import { Route as AppAdminUsersUserIdRouteImport } from './routes/_app/admin/users/$userId'
import { Route as AppServerServerIndexRouteImport } from './routes/_app/server/$server/index'
import { Route as AppServerServerActivityRouteImport } from './routes/_app/server/$server/activity'
import { Route as AppServerServerBackupsRouteImport } from './routes/_app/server/$server/backups'
import { Route as AppServerServerConfigRouteImport } from './routes/_app/server/$server/config'
import { Route as AppServerServerConsoleRouteImport } from './routes/_app/server/$server/console'
import { Route as AppServerServerDatabasesRouteImport } from './routes/_app/server/$server/databases'
import { Route as AppServerServerEditRouteImport } from './routes/_app/server/$server/edit'
import { Route as AppServerServerFilesRouteImport } from './routes/_app/server/$server/files'
import { Route as AppServerServerNetworkRouteImport } from './routes/_app/server/$server/network'
import { Route as AppServerServerOxideRouteImport } from './routes/_app/server/$server/oxide'
import { Route as AppServerServerPlayersRouteImport } from './routes/_app/server/$server/players'
import { Route as AppServerServerPluginsRouteImport } from './routes/_app/server/$server/plugins'
import { Route as AppServerServerSchedulesRouteImport } from './routes/_app/server/$server/schedules'
import { Route as AppServerServerSettingsRouteImport } from './routes/_app/server/$server/settings'
import { Route as AppServerServerStartupRouteImport } from './routes/_app/server/$server/startup'
import { Route as AppServerServerUsersRouteImport } from './routes/_app/server/$server/users'
import { Route as AppServerServerWipeRouteImport } from './routes/_app/server/$server/wipe'
import { Route as AppServerServerWorldsRouteImport } from './routes/_app/server/$server/worlds'
import { Route as AppAdminCustomisationPagesPageIdRouteImport } from './routes/_app/admin/customisation/pages.$pageId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestRoute = GuestRouteImport.update({
  id: '/_guest',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppAiRoute = AppAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AppRoute,
} as any)
const AppOverviewRoute = AppOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppRoute,
} as any)
const GuestForgotPasswordRoute = GuestForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => GuestRoute,
} as any)
const GuestLoginRoute = GuestLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => GuestRoute,
} as any)
const GuestRegisterRoute = GuestRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => GuestRoute,
} as any)
const GuestResetPasswordRoute = GuestResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => GuestRoute,
} as any)
const PSlugRoute = PSlugRouteImport.update({
  id: '/p/$slug',
  path: '/p/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountActivityRoute = AppAccountActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountAiRoute = AppAccountAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountApiKeysRoute = AppAccountApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountSecurityRoute = AppAccountSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountSettingsRoute = AppAccountSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountSshKeysRoute = AppAccountSshKeysRouteImport.update({
  id: '/ssh-keys',
  path: '/ssh-keys',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminActivityRoute = AppAdminActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAiRoute = AppAdminAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAllocationsRoute = AppAdminAllocationsRouteImport.update({
  id: '/allocations',
  path: '/allocations',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminApiKeysRoute = AppAdminApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminCustomisationRoute = AppAdminCustomisationRouteImport.update({
  id: '/customisation',
  path: '/customisation',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminDatabaseHostsRoute = AppAdminDatabaseHostsRouteImport.update({
  id: '/database-hosts',
  path: '/database-hosts',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminLocationsRoute = AppAdminLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSettingsRoute = AppAdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAiIndexRoute = AppAiIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAiRoute,
} as any)
const AppAiConversationIdRoute = AppAiConversationIdRouteImport.update({
  id: '/$conversationId',
  path: '/$conversationId',
  getParentRoute: () => AppAiRoute,
} as any)
const AppCustomSlugRoute = AppCustomSlugRouteImport.update({
  id: '/custom/$slug',
  path: '/custom/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppServerServerRoute = AppServerServerRouteImport.update({
  id: '/server/$server',
  path: '/server/$server',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminCustomisationIndexRoute =
  AppAdminCustomisationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminCustomisationRoute,
  } as any)
const AppAdminCustomisationAiRoute = AppAdminCustomisationAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AppAdminCustomisationRoute,
} as any)
const AppAdminCustomisationBrandingRoute =
  AppAdminCustomisationBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => AppAdminCustomisationRoute,
  } as any)
const AppAdminCustomisationDashboardRoute =
  AppAdminCustomisationDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AppAdminCustomisationRoute,
  } as any)
const AppAdminCustomisationHistoryRoute =
  AppAdminCustomisationHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => AppAdminCustomisationRoute,
  } as any)
const AppAdminCustomisationLoginRoute =
  AppAdminCustomisationLoginRouteImport.update({
    id: '/login',
    path: '/login',
    getParentRoute: () => AppAdminCustomisationRoute,
  } as any)
const AppAdminCustomisationPagesRoute =
  AppAdminCustomisationPagesRouteImport.update({
    id: '/pages',
    path: '/pages',
    getParentRoute: () => AppAdminCustomisationRoute,
  } as any)
const AppAdminCustomisationServerRoute =
  AppAdminCustomisationServerRouteImport.update({
    id: '/server',
    path: '/server',
    getParentRoute: () => AppAdminCustomisationRoute,
  } as any)
const AppAdminCustomisationTenantsRoute =
  AppAdminCustomisationTenantsRouteImport.update({
    id: '/tenants',
    path: '/tenants',
    getParentRoute: () => AppAdminCustomisationRoute,
  } as any)
const AppAdminCustomisationThemeRoute =
  AppAdminCustomisationThemeRouteImport.update({
    id: '/theme',
    path: '/theme',
    getParentRoute: () => AppAdminCustomisationRoute,
  } as any)
const AppAdminEggsEggIdRoute = AppAdminEggsEggIdRouteImport.update({
  id: '/eggs/$eggId',
  path: '/eggs/$eggId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminGameProfilesIndexRoute =
  AppAdminGameProfilesIndexRouteImport.update({
    id: '/game-profiles/',
    path: '/game-profiles/',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminGameProfilesProfileIdRoute =
  AppAdminGameProfilesProfileIdRouteImport.update({
    id: '/game-profiles/$profileId',
    path: '/game-profiles/$profileId',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminGameProfilesNewRoute = AppAdminGameProfilesNewRouteImport.update({
  id: '/game-profiles/new',
  path: '/game-profiles/new',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminNestsIndexRoute = AppAdminNestsIndexRouteImport.update({
  id: '/nests/',
  path: '/nests/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminNodesIndexRoute = AppAdminNodesIndexRouteImport.update({
  id: '/nodes/',
  path: '/nodes/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminNodesNodeIdRoute = AppAdminNodesNodeIdRouteImport.update({
  id: '/nodes/$nodeId',
  path: '/nodes/$nodeId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminNodesNewRoute = AppAdminNodesNewRouteImport.update({
  id: '/nodes/new',
  path: '/nodes/new',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminServersIndexRoute = AppAdminServersIndexRouteImport.update({
  id: '/servers/',
  path: '/servers/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminServersServerIdRoute = AppAdminServersServerIdRouteImport.update({
  id: '/servers/$serverId',
  path: '/servers/$serverId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminServersImportRoute = AppAdminServersImportRouteImport.update({
  id: '/servers/import',
  path: '/servers/import',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminServersNewRoute = AppAdminServersNewRouteImport.update({
  id: '/servers/new',
  path: '/servers/new',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersUserIdRoute = AppAdminUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppServerServerIndexRoute = AppServerServerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerActivityRoute = AppServerServerActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerBackupsRoute = AppServerServerBackupsRouteImport.update({
  id: '/backups',
  path: '/backups',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerConfigRoute = AppServerServerConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerConsoleRoute = AppServerServerConsoleRouteImport.update({
  id: '/console',
  path: '/console',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerDatabasesRoute =
  AppServerServerDatabasesRouteImport.update({
    id: '/databases',
    path: '/databases',
    getParentRoute: () => AppServerServerRoute,
  } as any)
const AppServerServerEditRoute = AppServerServerEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerFilesRoute = AppServerServerFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerNetworkRoute = AppServerServerNetworkRouteImport.update({
  id: '/network',
  path: '/network',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerOxideRoute = AppServerServerOxideRouteImport.update({
  id: '/oxide',
  path: '/oxide',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerPlayersRoute = AppServerServerPlayersRouteImport.update({
  id: '/players',
  path: '/players',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerPluginsRoute = AppServerServerPluginsRouteImport.update({
  id: '/plugins',
  path: '/plugins',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerSchedulesRoute =
  AppServerServerSchedulesRouteImport.update({
    id: '/schedules',
    path: '/schedules',
    getParentRoute: () => AppServerServerRoute,
  } as any)
const AppServerServerSettingsRoute = AppServerServerSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerStartupRoute = AppServerServerStartupRouteImport.update({
  id: '/startup',
  path: '/startup',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerUsersRoute = AppServerServerUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerWipeRoute = AppServerServerWipeRouteImport.update({
  id: '/wipe',
  path: '/wipe',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppServerServerWorldsRoute = AppServerServerWorldsRouteImport.update({
  id: '/worlds',
  path: '/worlds',
  getParentRoute: () => AppServerServerRoute,
} as any)
const AppAdminCustomisationPagesPageIdRoute =
  AppAdminCustomisationPagesPageIdRouteImport.update({
    id: '/$pageId',
    path: '/$pageId',
    getParentRoute: () => AppAdminCustomisationPagesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/verify-email': typeof VerifyEmailRoute
  '/account': typeof AppAccountRouteWithChildren
  '/admin': typeof AppAdminRouteWithChildren
  '/ai': typeof AppAiRouteWithChildren
  '/overview': typeof AppOverviewRoute
  '/forgot-password': typeof GuestForgotPasswordRoute
  '/login': typeof GuestLoginRoute
  '/register': typeof GuestRegisterRoute
  '/reset-password': typeof GuestResetPasswordRoute
  '/p/$slug': typeof PSlugRoute
  '/account/activity': typeof AppAccountActivityRoute
  '/account/ai': typeof AppAccountAiRoute
  '/account/api-keys': typeof AppAccountApiKeysRoute
  '/account/security': typeof AppAccountSecurityRoute
  '/account/settings': typeof AppAccountSettingsRoute
  '/account/ssh-keys': typeof AppAccountSshKeysRoute
  '/admin/activity': typeof AppAdminActivityRoute
  '/admin/ai': typeof AppAdminAiRoute
  '/admin/allocations': typeof AppAdminAllocationsRoute
  '/admin/api-keys': typeof AppAdminApiKeysRoute
  '/admin/customisation': typeof AppAdminCustomisationRouteWithChildren
  '/admin/database-hosts': typeof AppAdminDatabaseHostsRoute
  '/admin/locations': typeof AppAdminLocationsRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/ai/$conversationId': typeof AppAiConversationIdRoute
  '/custom/$slug': typeof AppCustomSlugRoute
  '/server/$server': typeof AppServerServerRouteWithChildren
  '/account/': typeof AppAccountIndexRoute
  '/admin/': typeof AppAdminIndexRoute
  '/ai/': typeof AppAiIndexRoute
  '/admin/customisation/ai': typeof AppAdminCustomisationAiRoute
  '/admin/customisation/branding': typeof AppAdminCustomisationBrandingRoute
  '/admin/customisation/dashboard': typeof AppAdminCustomisationDashboardRoute
  '/admin/customisation/history': typeof AppAdminCustomisationHistoryRoute
  '/admin/customisation/login': typeof AppAdminCustomisationLoginRoute
  '/admin/customisation/pages': typeof AppAdminCustomisationPagesRouteWithChildren
  '/admin/customisation/server': typeof AppAdminCustomisationServerRoute
  '/admin/customisation/tenants': typeof AppAdminCustomisationTenantsRoute
  '/admin/customisation/theme': typeof AppAdminCustomisationThemeRoute
  '/admin/eggs/$eggId': typeof AppAdminEggsEggIdRoute
  '/admin/game-profiles/$profileId': typeof AppAdminGameProfilesProfileIdRoute
  '/admin/game-profiles/new': typeof AppAdminGameProfilesNewRoute
  '/admin/nodes/$nodeId': typeof AppAdminNodesNodeIdRoute
  '/admin/nodes/new': typeof AppAdminNodesNewRoute
  '/admin/servers/$serverId': typeof AppAdminServersServerIdRoute
  '/admin/servers/import': typeof AppAdminServersImportRoute
  '/admin/servers/new': typeof AppAdminServersNewRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/server/$server/activity': typeof AppServerServerActivityRoute
  '/server/$server/backups': typeof AppServerServerBackupsRoute
  '/server/$server/config': typeof AppServerServerConfigRoute
  '/server/$server/console': typeof AppServerServerConsoleRoute
  '/server/$server/databases': typeof AppServerServerDatabasesRoute
  '/server/$server/edit': typeof AppServerServerEditRoute
  '/server/$server/files': typeof AppServerServerFilesRoute
  '/server/$server/network': typeof AppServerServerNetworkRoute
  '/server/$server/oxide': typeof AppServerServerOxideRoute
  '/server/$server/players': typeof AppServerServerPlayersRoute
  '/server/$server/plugins': typeof AppServerServerPluginsRoute
  '/server/$server/schedules': typeof AppServerServerSchedulesRoute
  '/server/$server/settings': typeof AppServerServerSettingsRoute
  '/server/$server/startup': typeof AppServerServerStartupRoute
  '/server/$server/users': typeof AppServerServerUsersRoute
  '/server/$server/wipe': typeof AppServerServerWipeRoute
  '/server/$server/worlds': typeof AppServerServerWorldsRoute
  '/admin/customisation/': typeof AppAdminCustomisationIndexRoute
  '/admin/game-profiles/': typeof AppAdminGameProfilesIndexRoute
  '/admin/nests/': typeof AppAdminNestsIndexRoute
  '/admin/nodes/': typeof AppAdminNodesIndexRoute
  '/admin/servers/': typeof AppAdminServersIndexRoute
  '/admin/users/': typeof AppAdminUsersIndexRoute
  '/server/$server/': typeof AppServerServerIndexRoute
  '/admin/customisation/pages/$pageId': typeof AppAdminCustomisationPagesPageIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/verify-email': typeof VerifyEmailRoute
  '/overview': typeof AppOverviewRoute
  '/forgot-password': typeof GuestForgotPasswordRoute
  '/login': typeof GuestLoginRoute
  '/register': typeof GuestRegisterRoute
  '/reset-password': typeof GuestResetPasswordRoute
  '/p/$slug': typeof PSlugRoute
  '/account/activity': typeof AppAccountActivityRoute
  '/account/ai': typeof AppAccountAiRoute
  '/account/api-keys': typeof AppAccountApiKeysRoute
  '/account/security': typeof AppAccountSecurityRoute
  '/account/settings': typeof AppAccountSettingsRoute
  '/account/ssh-keys': typeof AppAccountSshKeysRoute
  '/admin/activity': typeof AppAdminActivityRoute
  '/admin/ai': typeof AppAdminAiRoute
  '/admin/allocations': typeof AppAdminAllocationsRoute
  '/admin/api-keys': typeof AppAdminApiKeysRoute
  '/admin/database-hosts': typeof AppAdminDatabaseHostsRoute
  '/admin/locations': typeof AppAdminLocationsRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/ai/$conversationId': typeof AppAiConversationIdRoute
  '/custom/$slug': typeof AppCustomSlugRoute
  '/account': typeof AppAccountIndexRoute
  '/admin': typeof AppAdminIndexRoute
  '/ai': typeof AppAiIndexRoute
  '/admin/customisation/ai': typeof AppAdminCustomisationAiRoute
  '/admin/customisation/branding': typeof AppAdminCustomisationBrandingRoute
  '/admin/customisation/dashboard': typeof AppAdminCustomisationDashboardRoute
  '/admin/customisation/history': typeof AppAdminCustomisationHistoryRoute
  '/admin/customisation/login': typeof AppAdminCustomisationLoginRoute
  '/admin/customisation/pages': typeof AppAdminCustomisationPagesRouteWithChildren
  '/admin/customisation/server': typeof AppAdminCustomisationServerRoute
  '/admin/customisation/tenants': typeof AppAdminCustomisationTenantsRoute
  '/admin/customisation/theme': typeof AppAdminCustomisationThemeRoute
  '/admin/eggs/$eggId': typeof AppAdminEggsEggIdRoute
  '/admin/game-profiles/$profileId': typeof AppAdminGameProfilesProfileIdRoute
  '/admin/game-profiles/new': typeof AppAdminGameProfilesNewRoute
  '/admin/nodes/$nodeId': typeof AppAdminNodesNodeIdRoute
  '/admin/nodes/new': typeof AppAdminNodesNewRoute
  '/admin/servers/$serverId': typeof AppAdminServersServerIdRoute
  '/admin/servers/import': typeof AppAdminServersImportRoute
  '/admin/servers/new': typeof AppAdminServersNewRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/server/$server/activity': typeof AppServerServerActivityRoute
  '/server/$server/backups': typeof AppServerServerBackupsRoute
  '/server/$server/config': typeof AppServerServerConfigRoute
  '/server/$server/console': typeof AppServerServerConsoleRoute
  '/server/$server/databases': typeof AppServerServerDatabasesRoute
  '/server/$server/edit': typeof AppServerServerEditRoute
  '/server/$server/files': typeof AppServerServerFilesRoute
  '/server/$server/network': typeof AppServerServerNetworkRoute
  '/server/$server/oxide': typeof AppServerServerOxideRoute
  '/server/$server/players': typeof AppServerServerPlayersRoute
  '/server/$server/plugins': typeof AppServerServerPluginsRoute
  '/server/$server/schedules': typeof AppServerServerSchedulesRoute
  '/server/$server/settings': typeof AppServerServerSettingsRoute
  '/server/$server/startup': typeof AppServerServerStartupRoute
  '/server/$server/users': typeof AppServerServerUsersRoute
  '/server/$server/wipe': typeof AppServerServerWipeRoute
  '/server/$server/worlds': typeof AppServerServerWorldsRoute
  '/admin/customisation': typeof AppAdminCustomisationIndexRoute
  '/admin/game-profiles': typeof AppAdminGameProfilesIndexRoute
  '/admin/nests': typeof AppAdminNestsIndexRoute
  '/admin/nodes': typeof AppAdminNodesIndexRoute
  '/admin/servers': typeof AppAdminServersIndexRoute
  '/admin/users': typeof AppAdminUsersIndexRoute
  '/server/$server': typeof AppServerServerIndexRoute
  '/admin/customisation/pages/$pageId': typeof AppAdminCustomisationPagesPageIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_guest': typeof GuestRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/_app/account': typeof AppAccountRouteWithChildren
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/ai': typeof AppAiRouteWithChildren
  '/_app/overview': typeof AppOverviewRoute
  '/_guest/forgot-password': typeof GuestForgotPasswordRoute
  '/_guest/login': typeof GuestLoginRoute
  '/_guest/register': typeof GuestRegisterRoute
  '/_guest/reset-password': typeof GuestResetPasswordRoute
  '/p/$slug': typeof PSlugRoute
  '/_app/': typeof AppIndexRoute
  '/_app/account/activity': typeof AppAccountActivityRoute
  '/_app/account/ai': typeof AppAccountAiRoute
  '/_app/account/api-keys': typeof AppAccountApiKeysRoute
  '/_app/account/security': typeof AppAccountSecurityRoute
  '/_app/account/settings': typeof AppAccountSettingsRoute
  '/_app/account/ssh-keys': typeof AppAccountSshKeysRoute
  '/_app/admin/activity': typeof AppAdminActivityRoute
  '/_app/admin/ai': typeof AppAdminAiRoute
  '/_app/admin/allocations': typeof AppAdminAllocationsRoute
  '/_app/admin/api-keys': typeof AppAdminApiKeysRoute
  '/_app/admin/customisation': typeof AppAdminCustomisationRouteWithChildren
  '/_app/admin/database-hosts': typeof AppAdminDatabaseHostsRoute
  '/_app/admin/locations': typeof AppAdminLocationsRoute
  '/_app/admin/settings': typeof AppAdminSettingsRoute
  '/_app/ai/$conversationId': typeof AppAiConversationIdRoute
  '/_app/custom/$slug': typeof AppCustomSlugRoute
  '/_app/server/$server': typeof AppServerServerRouteWithChildren
  '/_app/account/': typeof AppAccountIndexRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/ai/': typeof AppAiIndexRoute
  '/_app/admin/customisation/ai': typeof AppAdminCustomisationAiRoute
  '/_app/admin/customisation/branding': typeof AppAdminCustomisationBrandingRoute
  '/_app/admin/customisation/dashboard': typeof AppAdminCustomisationDashboardRoute
  '/_app/admin/customisation/history': typeof AppAdminCustomisationHistoryRoute
  '/_app/admin/customisation/login': typeof AppAdminCustomisationLoginRoute
  '/_app/admin/customisation/pages': typeof AppAdminCustomisationPagesRouteWithChildren
  '/_app/admin/customisation/server': typeof AppAdminCustomisationServerRoute
  '/_app/admin/customisation/tenants': typeof AppAdminCustomisationTenantsRoute
  '/_app/admin/customisation/theme': typeof AppAdminCustomisationThemeRoute
  '/_app/admin/eggs/$eggId': typeof AppAdminEggsEggIdRoute
  '/_app/admin/game-profiles/$profileId': typeof AppAdminGameProfilesProfileIdRoute
  '/_app/admin/game-profiles/new': typeof AppAdminGameProfilesNewRoute
  '/_app/admin/nodes/$nodeId': typeof AppAdminNodesNodeIdRoute
  '/_app/admin/nodes/new': typeof AppAdminNodesNewRoute
  '/_app/admin/servers/$serverId': typeof AppAdminServersServerIdRoute
  '/_app/admin/servers/import': typeof AppAdminServersImportRoute
  '/_app/admin/servers/new': typeof AppAdminServersNewRoute
  '/_app/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/_app/server/$server/activity': typeof AppServerServerActivityRoute
  '/_app/server/$server/backups': typeof AppServerServerBackupsRoute
  '/_app/server/$server/config': typeof AppServerServerConfigRoute
  '/_app/server/$server/console': typeof AppServerServerConsoleRoute
  '/_app/server/$server/databases': typeof AppServerServerDatabasesRoute
  '/_app/server/$server/edit': typeof AppServerServerEditRoute
  '/_app/server/$server/files': typeof AppServerServerFilesRoute
  '/_app/server/$server/network': typeof AppServerServerNetworkRoute
  '/_app/server/$server/oxide': typeof AppServerServerOxideRoute
  '/_app/server/$server/players': typeof AppServerServerPlayersRoute
  '/_app/server/$server/plugins': typeof AppServerServerPluginsRoute
  '/_app/server/$server/schedules': typeof AppServerServerSchedulesRoute
  '/_app/server/$server/settings': typeof AppServerServerSettingsRoute
  '/_app/server/$server/startup': typeof AppServerServerStartupRoute
  '/_app/server/$server/users': typeof AppServerServerUsersRoute
  '/_app/server/$server/wipe': typeof AppServerServerWipeRoute
  '/_app/server/$server/worlds': typeof AppServerServerWorldsRoute
  '/_app/admin/customisation/': typeof AppAdminCustomisationIndexRoute
  '/_app/admin/game-profiles/': typeof AppAdminGameProfilesIndexRoute
  '/_app/admin/nests/': typeof AppAdminNestsIndexRoute
  '/_app/admin/nodes/': typeof AppAdminNodesIndexRoute
  '/_app/admin/servers/': typeof AppAdminServersIndexRoute
  '/_app/admin/users/': typeof AppAdminUsersIndexRoute
  '/_app/server/$server/': typeof AppServerServerIndexRoute
  '/_app/admin/customisation/pages/$pageId': typeof AppAdminCustomisationPagesPageIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/verify-email'
    | '/account'
    | '/admin'
    | '/ai'
    | '/overview'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/p/$slug'
    | '/account/activity'
    | '/account/ai'
    | '/account/api-keys'
    | '/account/security'
    | '/account/settings'
    | '/account/ssh-keys'
    | '/admin/activity'
    | '/admin/ai'
    | '/admin/allocations'
    | '/admin/api-keys'
    | '/admin/customisation'
    | '/admin/database-hosts'
    | '/admin/locations'
    | '/admin/settings'
    | '/ai/$conversationId'
    | '/custom/$slug'
    | '/server/$server'
    | '/account/'
    | '/admin/'
    | '/ai/'
    | '/admin/customisation/ai'
    | '/admin/customisation/branding'
    | '/admin/customisation/dashboard'
    | '/admin/customisation/history'
    | '/admin/customisation/login'
    | '/admin/customisation/pages'
    | '/admin/customisation/server'
    | '/admin/customisation/tenants'
    | '/admin/customisation/theme'
    | '/admin/eggs/$eggId'
    | '/admin/game-profiles/$profileId'
    | '/admin/game-profiles/new'
    | '/admin/nodes/$nodeId'
    | '/admin/nodes/new'
    | '/admin/servers/$serverId'
    | '/admin/servers/import'
    | '/admin/servers/new'
    | '/admin/users/$userId'
    | '/server/$server/activity'
    | '/server/$server/backups'
    | '/server/$server/config'
    | '/server/$server/console'
    | '/server/$server/databases'
    | '/server/$server/edit'
    | '/server/$server/files'
    | '/server/$server/network'
    | '/server/$server/oxide'
    | '/server/$server/players'
    | '/server/$server/plugins'
    | '/server/$server/schedules'
    | '/server/$server/settings'
    | '/server/$server/startup'
    | '/server/$server/users'
    | '/server/$server/wipe'
    | '/server/$server/worlds'
    | '/admin/customisation/'
    | '/admin/game-profiles/'
    | '/admin/nests/'
    | '/admin/nodes/'
    | '/admin/servers/'
    | '/admin/users/'
    | '/server/$server/'
    | '/admin/customisation/pages/$pageId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/verify-email'
    | '/overview'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/p/$slug'
    | '/account/activity'
    | '/account/ai'
    | '/account/api-keys'
    | '/account/security'
    | '/account/settings'
    | '/account/ssh-keys'
    | '/admin/activity'
    | '/admin/ai'
    | '/admin/allocations'
    | '/admin/api-keys'
    | '/admin/database-hosts'
    | '/admin/locations'
    | '/admin/settings'
    | '/ai/$conversationId'
    | '/custom/$slug'
    | '/account'
    | '/admin'
    | '/ai'
    | '/admin/customisation/ai'
    | '/admin/customisation/branding'
    | '/admin/customisation/dashboard'
    | '/admin/customisation/history'
    | '/admin/customisation/login'
    | '/admin/customisation/pages'
    | '/admin/customisation/server'
    | '/admin/customisation/tenants'
    | '/admin/customisation/theme'
    | '/admin/eggs/$eggId'
    | '/admin/game-profiles/$profileId'
    | '/admin/game-profiles/new'
    | '/admin/nodes/$nodeId'
    | '/admin/nodes/new'
    | '/admin/servers/$serverId'
    | '/admin/servers/import'
    | '/admin/servers/new'
    | '/admin/users/$userId'
    | '/server/$server/activity'
    | '/server/$server/backups'
    | '/server/$server/config'
    | '/server/$server/console'
    | '/server/$server/databases'
    | '/server/$server/edit'
    | '/server/$server/files'
    | '/server/$server/network'
    | '/server/$server/oxide'
    | '/server/$server/players'
    | '/server/$server/plugins'
    | '/server/$server/schedules'
    | '/server/$server/settings'
    | '/server/$server/startup'
    | '/server/$server/users'
    | '/server/$server/wipe'
    | '/server/$server/worlds'
    | '/admin/customisation'
    | '/admin/game-profiles'
    | '/admin/nests'
    | '/admin/nodes'
    | '/admin/servers'
    | '/admin/users'
    | '/server/$server'
    | '/admin/customisation/pages/$pageId'
  id:
    | '__root__'
    | '/_app'
    | '/_guest'
    | '/verify-email'
    | '/_app/account'
    | '/_app/admin'
    | '/_app/ai'
    | '/_app/overview'
    | '/_guest/forgot-password'
    | '/_guest/login'
    | '/_guest/register'
    | '/_guest/reset-password'
    | '/p/$slug'
    | '/_app/'
    | '/_app/account/activity'
    | '/_app/account/ai'
    | '/_app/account/api-keys'
    | '/_app/account/security'
    | '/_app/account/settings'
    | '/_app/account/ssh-keys'
    | '/_app/admin/activity'
    | '/_app/admin/ai'
    | '/_app/admin/allocations'
    | '/_app/admin/api-keys'
    | '/_app/admin/customisation'
    | '/_app/admin/database-hosts'
    | '/_app/admin/locations'
    | '/_app/admin/settings'
    | '/_app/ai/$conversationId'
    | '/_app/custom/$slug'
    | '/_app/server/$server'
    | '/_app/account/'
    | '/_app/admin/'
    | '/_app/ai/'
    | '/_app/admin/customisation/ai'
    | '/_app/admin/customisation/branding'
    | '/_app/admin/customisation/dashboard'
    | '/_app/admin/customisation/history'
    | '/_app/admin/customisation/login'
    | '/_app/admin/customisation/pages'
    | '/_app/admin/customisation/server'
    | '/_app/admin/customisation/tenants'
    | '/_app/admin/customisation/theme'
    | '/_app/admin/eggs/$eggId'
    | '/_app/admin/game-profiles/$profileId'
    | '/_app/admin/game-profiles/new'
    | '/_app/admin/nodes/$nodeId'
    | '/_app/admin/nodes/new'
    | '/_app/admin/servers/$serverId'
    | '/_app/admin/servers/import'
    | '/_app/admin/servers/new'
    | '/_app/admin/users/$userId'
    | '/_app/server/$server/activity'
    | '/_app/server/$server/backups'
    | '/_app/server/$server/config'
    | '/_app/server/$server/console'
    | '/_app/server/$server/databases'
    | '/_app/server/$server/edit'
    | '/_app/server/$server/files'
    | '/_app/server/$server/network'
    | '/_app/server/$server/oxide'
    | '/_app/server/$server/players'
    | '/_app/server/$server/plugins'
    | '/_app/server/$server/schedules'
    | '/_app/server/$server/settings'
    | '/_app/server/$server/startup'
    | '/_app/server/$server/users'
    | '/_app/server/$server/wipe'
    | '/_app/server/$server/worlds'
    | '/_app/admin/customisation/'
    | '/_app/admin/game-profiles/'
    | '/_app/admin/nests/'
    | '/_app/admin/nodes/'
    | '/_app/admin/servers/'
    | '/_app/admin/users/'
    | '/_app/server/$server/'
    | '/_app/admin/customisation/pages/$pageId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  GuestRoute: typeof GuestRouteWithChildren
  VerifyEmailRoute: typeof VerifyEmailRoute
  PSlugRoute: typeof PSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_guest': {
      id: '/_guest'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof GuestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai': {
      id: '/_app/ai'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AppAiRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/overview': {
      id: '/_app/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof AppOverviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_guest/forgot-password': {
      id: '/_guest/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof GuestForgotPasswordRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/login': {
      id: '/_guest/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof GuestLoginRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/register': {
      id: '/_guest/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof GuestRegisterRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/reset-password': {
      id: '/_guest/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof GuestResetPasswordRouteImport
      parentRoute: typeof GuestRoute
    }
    '/p/$slug': {
      id: '/p/$slug'
      path: '/p/$slug'
      fullPath: '/p/$slug'
      preLoaderRoute: typeof PSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account/': {
      id: '/_app/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/activity': {
      id: '/_app/account/activity'
      path: '/activity'
      fullPath: '/account/activity'
      preLoaderRoute: typeof AppAccountActivityRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/ai': {
      id: '/_app/account/ai'
      path: '/ai'
      fullPath: '/account/ai'
      preLoaderRoute: typeof AppAccountAiRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/api-keys': {
      id: '/_app/account/api-keys'
      path: '/api-keys'
      fullPath: '/account/api-keys'
      preLoaderRoute: typeof AppAccountApiKeysRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/security': {
      id: '/_app/account/security'
      path: '/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AppAccountSecurityRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/settings': {
      id: '/_app/account/settings'
      path: '/settings'
      fullPath: '/account/settings'
      preLoaderRoute: typeof AppAccountSettingsRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/ssh-keys': {
      id: '/_app/account/ssh-keys'
      path: '/ssh-keys'
      fullPath: '/account/ssh-keys'
      preLoaderRoute: typeof AppAccountSshKeysRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/activity': {
      id: '/_app/admin/activity'
      path: '/activity'
      fullPath: '/admin/activity'
      preLoaderRoute: typeof AppAdminActivityRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/ai': {
      id: '/_app/admin/ai'
      path: '/ai'
      fullPath: '/admin/ai'
      preLoaderRoute: typeof AppAdminAiRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/allocations': {
      id: '/_app/admin/allocations'
      path: '/allocations'
      fullPath: '/admin/allocations'
      preLoaderRoute: typeof AppAdminAllocationsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/api-keys': {
      id: '/_app/admin/api-keys'
      path: '/api-keys'
      fullPath: '/admin/api-keys'
      preLoaderRoute: typeof AppAdminApiKeysRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/customisation': {
      id: '/_app/admin/customisation'
      path: '/customisation'
      fullPath: '/admin/customisation'
      preLoaderRoute: typeof AppAdminCustomisationRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/database-hosts': {
      id: '/_app/admin/database-hosts'
      path: '/database-hosts'
      fullPath: '/admin/database-hosts'
      preLoaderRoute: typeof AppAdminDatabaseHostsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/locations': {
      id: '/_app/admin/locations'
      path: '/locations'
      fullPath: '/admin/locations'
      preLoaderRoute: typeof AppAdminLocationsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/settings': {
      id: '/_app/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AppAdminSettingsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/ai/': {
      id: '/_app/ai/'
      path: '/'
      fullPath: '/ai/'
      preLoaderRoute: typeof AppAiIndexRouteImport
      parentRoute: typeof AppAiRoute
    }
    '/_app/ai/$conversationId': {
      id: '/_app/ai/$conversationId'
      path: '/$conversationId'
      fullPath: '/ai/$conversationId'
      preLoaderRoute: typeof AppAiConversationIdRouteImport
      parentRoute: typeof AppAiRoute
    }
    '/_app/custom/$slug': {
      id: '/_app/custom/$slug'
      path: '/custom/$slug'
      fullPath: '/custom/$slug'
      preLoaderRoute: typeof AppCustomSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/server/$server': {
      id: '/_app/server/$server'
      path: '/server/$server'
      fullPath: '/server/$server'
      preLoaderRoute: typeof AppServerServerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/customisation/': {
      id: '/_app/admin/customisation/'
      path: '/'
      fullPath: '/admin/customisation/'
      preLoaderRoute: typeof AppAdminCustomisationIndexRouteImport
      parentRoute: typeof AppAdminCustomisationRoute
    }
    '/_app/admin/customisation/ai': {
      id: '/_app/admin/customisation/ai'
      path: '/ai'
      fullPath: '/admin/customisation/ai'
      preLoaderRoute: typeof AppAdminCustomisationAiRouteImport
      parentRoute: typeof AppAdminCustomisationRoute
    }
    '/_app/admin/customisation/branding': {
      id: '/_app/admin/customisation/branding'
      path: '/branding'
      fullPath: '/admin/customisation/branding'
      preLoaderRoute: typeof AppAdminCustomisationBrandingRouteImport
      parentRoute: typeof AppAdminCustomisationRoute
    }
    '/_app/admin/customisation/dashboard': {
      id: '/_app/admin/customisation/dashboard'
      path: '/dashboard'
      fullPath: '/admin/customisation/dashboard'
      preLoaderRoute: typeof AppAdminCustomisationDashboardRouteImport
      parentRoute: typeof AppAdminCustomisationRoute
    }
    '/_app/admin/customisation/history': {
      id: '/_app/admin/customisation/history'
      path: '/history'
      fullPath: '/admin/customisation/history'
      preLoaderRoute: typeof AppAdminCustomisationHistoryRouteImport
      parentRoute: typeof AppAdminCustomisationRoute
    }
    '/_app/admin/customisation/login': {
      id: '/_app/admin/customisation/login'
      path: '/login'
      fullPath: '/admin/customisation/login'
      preLoaderRoute: typeof AppAdminCustomisationLoginRouteImport
      parentRoute: typeof AppAdminCustomisationRoute
    }
    '/_app/admin/customisation/pages': {
      id: '/_app/admin/customisation/pages'
      path: '/pages'
      fullPath: '/admin/customisation/pages'
      preLoaderRoute: typeof AppAdminCustomisationPagesRouteImport
      parentRoute: typeof AppAdminCustomisationRoute
    }
    '/_app/admin/customisation/server': {
      id: '/_app/admin/customisation/server'
      path: '/server'
      fullPath: '/admin/customisation/server'
      preLoaderRoute: typeof AppAdminCustomisationServerRouteImport
      parentRoute: typeof AppAdminCustomisationRoute
    }
    '/_app/admin/customisation/tenants': {
      id: '/_app/admin/customisation/tenants'
      path: '/tenants'
      fullPath: '/admin/customisation/tenants'
      preLoaderRoute: typeof AppAdminCustomisationTenantsRouteImport
      parentRoute: typeof AppAdminCustomisationRoute
    }
    '/_app/admin/customisation/theme': {
      id: '/_app/admin/customisation/theme'
      path: '/theme'
      fullPath: '/admin/customisation/theme'
      preLoaderRoute: typeof AppAdminCustomisationThemeRouteImport
      parentRoute: typeof AppAdminCustomisationRoute
    }
    '/_app/admin/eggs/$eggId': {
      id: '/_app/admin/eggs/$eggId'
      path: '/eggs/$eggId'
      fullPath: '/admin/eggs/$eggId'
      preLoaderRoute: typeof AppAdminEggsEggIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/game-profiles/': {
      id: '/_app/admin/game-profiles/'
      path: '/game-profiles'
      fullPath: '/admin/game-profiles/'
      preLoaderRoute: typeof AppAdminGameProfilesIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/game-profiles/$profileId': {
      id: '/_app/admin/game-profiles/$profileId'
      path: '/game-profiles/$profileId'
      fullPath: '/admin/game-profiles/$profileId'
      preLoaderRoute: typeof AppAdminGameProfilesProfileIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/game-profiles/new': {
      id: '/_app/admin/game-profiles/new'
      path: '/game-profiles/new'
      fullPath: '/admin/game-profiles/new'
      preLoaderRoute: typeof AppAdminGameProfilesNewRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/nests/': {
      id: '/_app/admin/nests/'
      path: '/nests'
      fullPath: '/admin/nests/'
      preLoaderRoute: typeof AppAdminNestsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/nodes/': {
      id: '/_app/admin/nodes/'
      path: '/nodes'
      fullPath: '/admin/nodes/'
      preLoaderRoute: typeof AppAdminNodesIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/nodes/$nodeId': {
      id: '/_app/admin/nodes/$nodeId'
      path: '/nodes/$nodeId'
      fullPath: '/admin/nodes/$nodeId'
      preLoaderRoute: typeof AppAdminNodesNodeIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/nodes/new': {
      id: '/_app/admin/nodes/new'
      path: '/nodes/new'
      fullPath: '/admin/nodes/new'
      preLoaderRoute: typeof AppAdminNodesNewRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/servers/': {
      id: '/_app/admin/servers/'
      path: '/servers'
      fullPath: '/admin/servers/'
      preLoaderRoute: typeof AppAdminServersIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/servers/$serverId': {
      id: '/_app/admin/servers/$serverId'
      path: '/servers/$serverId'
      fullPath: '/admin/servers/$serverId'
      preLoaderRoute: typeof AppAdminServersServerIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/servers/import': {
      id: '/_app/admin/servers/import'
      path: '/servers/import'
      fullPath: '/admin/servers/import'
      preLoaderRoute: typeof AppAdminServersImportRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/servers/new': {
      id: '/_app/admin/servers/new'
      path: '/servers/new'
      fullPath: '/admin/servers/new'
      preLoaderRoute: typeof AppAdminServersNewRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/': {
      id: '/_app/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/$userId': {
      id: '/_app/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AppAdminUsersUserIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/server/$server/': {
      id: '/_app/server/$server/'
      path: '/'
      fullPath: '/server/$server/'
      preLoaderRoute: typeof AppServerServerIndexRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/activity': {
      id: '/_app/server/$server/activity'
      path: '/activity'
      fullPath: '/server/$server/activity'
      preLoaderRoute: typeof AppServerServerActivityRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/backups': {
      id: '/_app/server/$server/backups'
      path: '/backups'
      fullPath: '/server/$server/backups'
      preLoaderRoute: typeof AppServerServerBackupsRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/config': {
      id: '/_app/server/$server/config'
      path: '/config'
      fullPath: '/server/$server/config'
      preLoaderRoute: typeof AppServerServerConfigRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/console': {
      id: '/_app/server/$server/console'
      path: '/console'
      fullPath: '/server/$server/console'
      preLoaderRoute: typeof AppServerServerConsoleRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/databases': {
      id: '/_app/server/$server/databases'
      path: '/databases'
      fullPath: '/server/$server/databases'
      preLoaderRoute: typeof AppServerServerDatabasesRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/edit': {
      id: '/_app/server/$server/edit'
      path: '/edit'
      fullPath: '/server/$server/edit'
      preLoaderRoute: typeof AppServerServerEditRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/files': {
      id: '/_app/server/$server/files'
      path: '/files'
      fullPath: '/server/$server/files'
      preLoaderRoute: typeof AppServerServerFilesRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/network': {
      id: '/_app/server/$server/network'
      path: '/network'
      fullPath: '/server/$server/network'
      preLoaderRoute: typeof AppServerServerNetworkRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/oxide': {
      id: '/_app/server/$server/oxide'
      path: '/oxide'
      fullPath: '/server/$server/oxide'
      preLoaderRoute: typeof AppServerServerOxideRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/players': {
      id: '/_app/server/$server/players'
      path: '/players'
      fullPath: '/server/$server/players'
      preLoaderRoute: typeof AppServerServerPlayersRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/plugins': {
      id: '/_app/server/$server/plugins'
      path: '/plugins'
      fullPath: '/server/$server/plugins'
      preLoaderRoute: typeof AppServerServerPluginsRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/schedules': {
      id: '/_app/server/$server/schedules'
      path: '/schedules'
      fullPath: '/server/$server/schedules'
      preLoaderRoute: typeof AppServerServerSchedulesRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/settings': {
      id: '/_app/server/$server/settings'
      path: '/settings'
      fullPath: '/server/$server/settings'
      preLoaderRoute: typeof AppServerServerSettingsRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/startup': {
      id: '/_app/server/$server/startup'
      path: '/startup'
      fullPath: '/server/$server/startup'
      preLoaderRoute: typeof AppServerServerStartupRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/users': {
      id: '/_app/server/$server/users'
      path: '/users'
      fullPath: '/server/$server/users'
      preLoaderRoute: typeof AppServerServerUsersRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/wipe': {
      id: '/_app/server/$server/wipe'
      path: '/wipe'
      fullPath: '/server/$server/wipe'
      preLoaderRoute: typeof AppServerServerWipeRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/server/$server/worlds': {
      id: '/_app/server/$server/worlds'
      path: '/worlds'
      fullPath: '/server/$server/worlds'
      preLoaderRoute: typeof AppServerServerWorldsRouteImport
      parentRoute: typeof AppServerServerRoute
    }
    '/_app/admin/customisation/pages/$pageId': {
      id: '/_app/admin/customisation/pages/$pageId'
      path: '/$pageId'
      fullPath: '/admin/customisation/pages/$pageId'
      preLoaderRoute: typeof AppAdminCustomisationPagesPageIdRouteImport
      parentRoute: typeof AppAdminCustomisationPagesRoute
    }
  }
}

interface AppAccountRouteChildren {
  AppAccountActivityRoute: typeof AppAccountActivityRoute
  AppAccountAiRoute: typeof AppAccountAiRoute
  AppAccountApiKeysRoute: typeof AppAccountApiKeysRoute
  AppAccountSecurityRoute: typeof AppAccountSecurityRoute
  AppAccountSettingsRoute: typeof AppAccountSettingsRoute
  AppAccountSshKeysRoute: typeof AppAccountSshKeysRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
}

const AppAccountRouteChildren: AppAccountRouteChildren = {
  AppAccountActivityRoute: AppAccountActivityRoute,
  AppAccountAiRoute: AppAccountAiRoute,
  AppAccountApiKeysRoute: AppAccountApiKeysRoute,
  AppAccountSecurityRoute: AppAccountSecurityRoute,
  AppAccountSettingsRoute: AppAccountSettingsRoute,
  AppAccountSshKeysRoute: AppAccountSshKeysRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
}

const AppAccountRouteWithChildren = AppAccountRoute._addFileChildren(
  AppAccountRouteChildren,
)

interface AppAdminCustomisationPagesRouteChildren {
  AppAdminCustomisationPagesPageIdRoute: typeof AppAdminCustomisationPagesPageIdRoute
}

const AppAdminCustomisationPagesRouteChildren: AppAdminCustomisationPagesRouteChildren =
  {
    AppAdminCustomisationPagesPageIdRoute:
      AppAdminCustomisationPagesPageIdRoute,
  }

const AppAdminCustomisationPagesRouteWithChildren =
  AppAdminCustomisationPagesRoute._addFileChildren(
    AppAdminCustomisationPagesRouteChildren,
  )

interface AppAdminCustomisationRouteChildren {
  AppAdminCustomisationAiRoute: typeof AppAdminCustomisationAiRoute
  AppAdminCustomisationBrandingRoute: typeof AppAdminCustomisationBrandingRoute
  AppAdminCustomisationDashboardRoute: typeof AppAdminCustomisationDashboardRoute
  AppAdminCustomisationHistoryRoute: typeof AppAdminCustomisationHistoryRoute
  AppAdminCustomisationLoginRoute: typeof AppAdminCustomisationLoginRoute
  AppAdminCustomisationPagesRoute: typeof AppAdminCustomisationPagesRouteWithChildren
  AppAdminCustomisationServerRoute: typeof AppAdminCustomisationServerRoute
  AppAdminCustomisationTenantsRoute: typeof AppAdminCustomisationTenantsRoute
  AppAdminCustomisationThemeRoute: typeof AppAdminCustomisationThemeRoute
  AppAdminCustomisationIndexRoute: typeof AppAdminCustomisationIndexRoute
}

const AppAdminCustomisationRouteChildren: AppAdminCustomisationRouteChildren = {
  AppAdminCustomisationAiRoute: AppAdminCustomisationAiRoute,
  AppAdminCustomisationBrandingRoute: AppAdminCustomisationBrandingRoute,
  AppAdminCustomisationDashboardRoute: AppAdminCustomisationDashboardRoute,
  AppAdminCustomisationHistoryRoute: AppAdminCustomisationHistoryRoute,
  AppAdminCustomisationLoginRoute: AppAdminCustomisationLoginRoute,
  AppAdminCustomisationPagesRoute: AppAdminCustomisationPagesRouteWithChildren,
  AppAdminCustomisationServerRoute: AppAdminCustomisationServerRoute,
  AppAdminCustomisationTenantsRoute: AppAdminCustomisationTenantsRoute,
  AppAdminCustomisationThemeRoute: AppAdminCustomisationThemeRoute,
  AppAdminCustomisationIndexRoute: AppAdminCustomisationIndexRoute,
}

const AppAdminCustomisationRouteWithChildren =
  AppAdminCustomisationRoute._addFileChildren(
    AppAdminCustomisationRouteChildren,
  )

interface AppAdminRouteChildren {
  AppAdminActivityRoute: typeof AppAdminActivityRoute
  AppAdminAiRoute: typeof AppAdminAiRoute
  AppAdminAllocationsRoute: typeof AppAdminAllocationsRoute
  AppAdminApiKeysRoute: typeof AppAdminApiKeysRoute
  AppAdminCustomisationRoute: typeof AppAdminCustomisationRouteWithChildren
  AppAdminDatabaseHostsRoute: typeof AppAdminDatabaseHostsRoute
  AppAdminLocationsRoute: typeof AppAdminLocationsRoute
  AppAdminSettingsRoute: typeof AppAdminSettingsRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminEggsEggIdRoute: typeof AppAdminEggsEggIdRoute
  AppAdminGameProfilesProfileIdRoute: typeof AppAdminGameProfilesProfileIdRoute
  AppAdminGameProfilesNewRoute: typeof AppAdminGameProfilesNewRoute
  AppAdminNodesNodeIdRoute: typeof AppAdminNodesNodeIdRoute
  AppAdminNodesNewRoute: typeof AppAdminNodesNewRoute
  AppAdminServersServerIdRoute: typeof AppAdminServersServerIdRoute
  AppAdminServersImportRoute: typeof AppAdminServersImportRoute
  AppAdminServersNewRoute: typeof AppAdminServersNewRoute
  AppAdminUsersUserIdRoute: typeof AppAdminUsersUserIdRoute
  AppAdminGameProfilesIndexRoute: typeof AppAdminGameProfilesIndexRoute
  AppAdminNestsIndexRoute: typeof AppAdminNestsIndexRoute
  AppAdminNodesIndexRoute: typeof AppAdminNodesIndexRoute
  AppAdminServersIndexRoute: typeof AppAdminServersIndexRoute
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminActivityRoute: AppAdminActivityRoute,
  AppAdminAiRoute: AppAdminAiRoute,
  AppAdminAllocationsRoute: AppAdminAllocationsRoute,
  AppAdminApiKeysRoute: AppAdminApiKeysRoute,
  AppAdminCustomisationRoute: AppAdminCustomisationRouteWithChildren,
  AppAdminDatabaseHostsRoute: AppAdminDatabaseHostsRoute,
  AppAdminLocationsRoute: AppAdminLocationsRoute,
  AppAdminSettingsRoute: AppAdminSettingsRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminEggsEggIdRoute: AppAdminEggsEggIdRoute,
  AppAdminGameProfilesProfileIdRoute: AppAdminGameProfilesProfileIdRoute,
  AppAdminGameProfilesNewRoute: AppAdminGameProfilesNewRoute,
  AppAdminNodesNodeIdRoute: AppAdminNodesNodeIdRoute,
  AppAdminNodesNewRoute: AppAdminNodesNewRoute,
  AppAdminServersServerIdRoute: AppAdminServersServerIdRoute,
  AppAdminServersImportRoute: AppAdminServersImportRoute,
  AppAdminServersNewRoute: AppAdminServersNewRoute,
  AppAdminUsersUserIdRoute: AppAdminUsersUserIdRoute,
  AppAdminGameProfilesIndexRoute: AppAdminGameProfilesIndexRoute,
  AppAdminNestsIndexRoute: AppAdminNestsIndexRoute,
  AppAdminNodesIndexRoute: AppAdminNodesIndexRoute,
  AppAdminServersIndexRoute: AppAdminServersIndexRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppAiRouteChildren {
  AppAiConversationIdRoute: typeof AppAiConversationIdRoute
  AppAiIndexRoute: typeof AppAiIndexRoute
}

const AppAiRouteChildren: AppAiRouteChildren = {
  AppAiConversationIdRoute: AppAiConversationIdRoute,
  AppAiIndexRoute: AppAiIndexRoute,
}

const AppAiRouteWithChildren = AppAiRoute._addFileChildren(AppAiRouteChildren)

interface AppServerServerRouteChildren {
  AppServerServerActivityRoute: typeof AppServerServerActivityRoute
  AppServerServerBackupsRoute: typeof AppServerServerBackupsRoute
  AppServerServerConfigRoute: typeof AppServerServerConfigRoute
  AppServerServerConsoleRoute: typeof AppServerServerConsoleRoute
  AppServerServerDatabasesRoute: typeof AppServerServerDatabasesRoute
  AppServerServerEditRoute: typeof AppServerServerEditRoute
  AppServerServerFilesRoute: typeof AppServerServerFilesRoute
  AppServerServerNetworkRoute: typeof AppServerServerNetworkRoute
  AppServerServerOxideRoute: typeof AppServerServerOxideRoute
  AppServerServerPlayersRoute: typeof AppServerServerPlayersRoute
  AppServerServerPluginsRoute: typeof AppServerServerPluginsRoute
  AppServerServerSchedulesRoute: typeof AppServerServerSchedulesRoute
  AppServerServerSettingsRoute: typeof AppServerServerSettingsRoute
  AppServerServerStartupRoute: typeof AppServerServerStartupRoute
  AppServerServerUsersRoute: typeof AppServerServerUsersRoute
  AppServerServerWipeRoute: typeof AppServerServerWipeRoute
  AppServerServerWorldsRoute: typeof AppServerServerWorldsRoute
  AppServerServerIndexRoute: typeof AppServerServerIndexRoute
}

const AppServerServerRouteChildren: AppServerServerRouteChildren = {
  AppServerServerActivityRoute: AppServerServerActivityRoute,
  AppServerServerBackupsRoute: AppServerServerBackupsRoute,
  AppServerServerConfigRoute: AppServerServerConfigRoute,
  AppServerServerConsoleRoute: AppServerServerConsoleRoute,
  AppServerServerDatabasesRoute: AppServerServerDatabasesRoute,
  AppServerServerEditRoute: AppServerServerEditRoute,
  AppServerServerFilesRoute: AppServerServerFilesRoute,
  AppServerServerNetworkRoute: AppServerServerNetworkRoute,
  AppServerServerOxideRoute: AppServerServerOxideRoute,
  AppServerServerPlayersRoute: AppServerServerPlayersRoute,
  AppServerServerPluginsRoute: AppServerServerPluginsRoute,
  AppServerServerSchedulesRoute: AppServerServerSchedulesRoute,
  AppServerServerSettingsRoute: AppServerServerSettingsRoute,
  AppServerServerStartupRoute: AppServerServerStartupRoute,
  AppServerServerUsersRoute: AppServerServerUsersRoute,
  AppServerServerWipeRoute: AppServerServerWipeRoute,
  AppServerServerWorldsRoute: AppServerServerWorldsRoute,
  AppServerServerIndexRoute: AppServerServerIndexRoute,
}

const AppServerServerRouteWithChildren = AppServerServerRoute._addFileChildren(
  AppServerServerRouteChildren,
)

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRouteWithChildren
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppAiRoute: typeof AppAiRouteWithChildren
  AppOverviewRoute: typeof AppOverviewRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCustomSlugRoute: typeof AppCustomSlugRoute
  AppServerServerRoute: typeof AppServerServerRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRouteWithChildren,
  AppAdminRoute: AppAdminRouteWithChildren,
  AppAiRoute: AppAiRouteWithChildren,
  AppOverviewRoute: AppOverviewRoute,
  AppIndexRoute: AppIndexRoute,
  AppCustomSlugRoute: AppCustomSlugRoute,
  AppServerServerRoute: AppServerServerRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface GuestRouteChildren {
  GuestForgotPasswordRoute: typeof GuestForgotPasswordRoute
  GuestLoginRoute: typeof GuestLoginRoute
  GuestRegisterRoute: typeof GuestRegisterRoute
  GuestResetPasswordRoute: typeof GuestResetPasswordRoute
}

const GuestRouteChildren: GuestRouteChildren = {
  GuestForgotPasswordRoute: GuestForgotPasswordRoute,
  GuestLoginRoute: GuestLoginRoute,
  GuestRegisterRoute: GuestRegisterRoute,
  GuestResetPasswordRoute: GuestResetPasswordRoute,
}

const GuestRouteWithChildren = GuestRoute._addFileChildren(GuestRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  GuestRoute: GuestRouteWithChildren,
  VerifyEmailRoute: VerifyEmailRoute,
  PSlugRoute: PSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
